// extracted by mini-css-extract-plugin
export default {"container":"sda-z","creativeContainer":"tda-z","copy":"uda-z","cta":"vda-z","disabled":"wda-z","flipped":"xda-z","productCard":"yda-z"};